/* eslint-disable no-param-reassign */
import { useMemo } from "react";

import { every } from "lodash";

import {
  GraduationCapSolidV6,
  PhoneVolumeSolidV6,
  PlaceCustomv6,
  UserGraduateSolidV6,
} from "../../../shared/v2/Icomoon";

import Loader from "../../../Dashboard/components/Loader";
import {
  useAppLinks,
  useAppLinksLoading,
  useCurrentUser,
  useFeatureFlags,
} from "../../../reducers/layoutReducer/selectors";
import ResourceLauncher from "./ResourceLauncher";

const checkLinkUrls = (placeLaunchers) => !every(placeLaunchers, ([, item]) => item.linkUrl === "/");

const DEFAULT_PLACE_RESOURCES = {
  "PLACE Academy": { Icon: GraduationCapSolidV6, linkUrl: "https://learn.place.com/enrollments" },
  "Report Cards": { Icon: UserGraduateSolidV6, linkUrl: "https://learn.place.com/manage/reports/groups" },
  "Our PLACE": { Icon: PlaceCustomv6, linkUrl: "/" },
  "Gabbi Call IQ": { Icon: PhoneVolumeSolidV6, linkUrl: "/launch/ai_call_coach" },
};

const PlaceResources = () => {
  const { isAdmin } = useCurrentUser().account;
  const isLoading = useAppLinksLoading();
  const appLinks = useAppLinks();
  const featureFlags = useFeatureFlags();

  const resourcesByLabel = useMemo(() => {
    const resources = { ...DEFAULT_PLACE_RESOURCES };
    if (!isAdmin) delete resources["Report Cards"];
    if (!featureFlags.aiCallCoaching) delete resources["Gabbi Call IQ"];
    appLinks?.forEach(({ label, linkUrl }) => {
      if (resources[label]) resources[label].linkUrl = linkUrl;
    });
    return resources;
  }, [appLinks, isAdmin]);

  const iterativeResources = Object.entries(resourcesByLabel);

  return (
    checkLinkUrls(iterativeResources) && (
      <div className="tw-p-[16px] tw-border-b-color-ebebeb tw-border-solid tw-border-l-0 tw-border-b-[3px] tw-border-r-0 tw-border-t-0">
        <div className="tw-flex tw-justify-start tw-items-center tw-mb-[8px]">
          <span className="tw-text-black">PLACE Resources</span>
        </div>
        <div className="tw-flex tw-justify-between tw-flex-wrap">
          {isLoading && <Loader containerClass="tw-pt-0 tw-flex tw-items-center" />}
          {iterativeResources
            .filter(([, { linkUrl }]) => linkUrl !== "/")
            .map(([label, { Icon, linkUrl }]) => (
              <ResourceLauncher label={label} Icon={Icon} linkUrl={linkUrl} key={label} />
            ))}
        </div>
      </div>
    )
  );
};

export default PlaceResources;
